import { addProp } from "@pnp/odata";
import { _Web } from "../webs/types.js";
import { Features } from "./types.js";
addProp(_Web, "features", Features);
//# sourceMappingURL=web.js.map